import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import {handleAPIErrors} from '../utils';
import {SnackbarProvider, withSnackbar} from 'notistack';
import {SaveButton, SimpleForm, TextInput, Toolbar, withDataProvider} from 'react-admin';

const styles = {
  settingsContainer: {
    width: '100%',
    maxWidth: '1140px',
    margin: '25px auto',
    backgroundColor: '#fff',
  },
  complianceDashboardAccess: {
    padding: '40px 0',
  },
  singleAccessType: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  reportType: {},
  idInput: {
    width: '95%',
  },
  powerBiRoles: {
    padding: '60px 0',
  },
  table: {
    marginTop: '15px',
  },
  progressBar: {
    flex: '1',
    alignSelf: 'center',
  },
  form: {
    width: '100%',
  },
};

class styledComplianceDashboardSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessLevels: [],
      basicAccessLevel: {},
      advancedAccessLevel: {},
    };

    ({dataProvider: this.dataProvider} = this.props);
    this.getAccessLevels();
  }

  getAccessLevels = () => {
    return this.dataProvider.getList('compliance_dashboard_access_levels', {
      pagination: {
        page: 1,
      },
      sort: {
        field: '@id',
        order: 'ASC',
      },
    })
      .then((accessLevelsResponse) => {
        let basicAccessLevel = accessLevelsResponse.data.find(accessLevel => {
          return accessLevel.accessLevel === 'compliance_dashboard_basic';
        });

        let advancedAccessLevel = accessLevelsResponse.data.find(accessLevel => {
          return accessLevel.accessLevel === 'compliance_dashboard_advanced';
        });

        this.setState({
          accessLevels: accessLevelsResponse.data,
          basicAccessLevel: basicAccessLevel,
          advancedAccessLevel: advancedAccessLevel,
        });
      })
      .catch(error => {
        handleAPIErrors(error, this.props.history);
        console.error(error);
      });
  };

  submitForm = (formData) => {
    this.submitReportIds(formData);
  };

  isBasicAccessLevelDataTouched = formData => {
    return this.state.basicAccessLevel.powerBiGroupId !== formData.basicPowerBiGroupId ||
      this.state.basicAccessLevel.powerBiReportId !== formData.basicReportId ||
      this.state.basicAccessLevel.powerBiDatasetId !== formData.basicDatasetId ||
      this.state.basicAccessLevel.powerBiGroupIdScope2 !== formData.basicPowerBiGroupIdScope2 ||
      this.state.basicAccessLevel.powerBiReportIdScope2 !== formData.basicReportIdScope2 ||
      this.state.basicAccessLevel.powerBiDatasetIdScope2 !== formData.basicDatasetIdScope2 ||
      this.state.basicAccessLevel.powerBiGroupIdScope3 !== formData.basicPowerBiGroupIdScope3 ||
      this.state.basicAccessLevel.powerBiReportIdScope3 !== formData.basicReportIdScope3 ||
      this.state.basicAccessLevel.powerBiDatasetIdScope3 !== formData.basicDatasetIdScope3 ||
      this.state.basicAccessLevel.powerBiGroupIdScope4 !== formData.basicPowerBiGroupIdScope4 ||
      this.state.basicAccessLevel.powerBiReportIdScope4 !== formData.basicReportIdScope4 ||
      this.state.basicAccessLevel.powerBiDatasetIdScope4 !== formData.basicDatasetIdScope4 ||
      this.state.basicAccessLevel.powerBiGroupIdScope5 !== formData.basicPowerBiGroupIdScope5 ||
      this.state.basicAccessLevel.powerBiReportIdScope5 !== formData.basicReportIdScope5 ||
      this.state.basicAccessLevel.powerBiDatasetIdScope5 !== formData.basicDatasetIdScope5 ||
      this.state.basicAccessLevel.powerBiGroupIdScope6 !== formData.basicPowerBiGroupIdScope6 ||
      this.state.basicAccessLevel.powerBiReportIdScope6 !== formData.basicReportIdScope6 ||
      this.state.basicAccessLevel.powerBiDatasetIdScope6 !== formData.basicDatasetIdScope6;
    };

  isAdvancedAccessLevelDataTouched = formData => {
    return this.state.advancedAccessLevel.powerBiGroupId !== formData.advancedPowerBiGroupId ||
      this.state.advancedAccessLevel.powerBiReportId !== formData.advancedReportId ||
      this.state.advancedAccessLevel.powerBiDatasetId !== formData.advancedDatasetId ||
      this.state.advancedAccessLevel.powerBiGroupIdScope2 !== formData.advancedPowerBiGroupIdScope2 ||
      this.state.advancedAccessLevel.powerBiReportIdScope2 !== formData.advancedReportIdScope2 ||
      this.state.advancedAccessLevel.powerBiDatasetIdScope2 !== formData.advancedDatasetIdScope2 ||
      this.state.advancedAccessLevel.powerBiGroupIdScope3 !== formData.advancedPowerBiGroupIdScope3 ||
      this.state.advancedAccessLevel.powerBiReportIdScope3 !== formData.advancedReportIdScope3 ||
      this.state.advancedAccessLevel.powerBiDatasetIdScope3 !== formData.advancedDatasetIdScope3 ||
      this.state.advancedAccessLevel.powerBiGroupIdScope4 !== formData.advancedPowerBiGroupIdScope4 ||
      this.state.advancedAccessLevel.powerBiReportIdScope4 !== formData.advancedReportIdScope4 ||
      this.state.advancedAccessLevel.powerBiDatasetIdScope4 !== formData.advancedDatasetIdScope4 ||
      this.state.advancedAccessLevel.powerBiGroupIdScope5 !== formData.advancedPowerBiGroupIdScope5 ||
      this.state.advancedAccessLevel.powerBiReportIdScope5 !== formData.advancedReportIdScope5 ||
      this.state.advancedAccessLevel.powerBiDatasetIdScope5 !== formData.advancedDatasetIdScope5 ||
      this.state.advancedAccessLevel.powerBiGroupIdScope6 !== formData.advancedPowerBiGroupIdScope6 ||
      this.state.advancedAccessLevel.powerBiReportIdScope6 !== formData.advancedReportIdScope6 ||
      this.state.advancedAccessLevel.powerBiDatasetIdScope6 !== formData.advancedDatasetIdScope6;
  };

  submitReportIds = (formData) => {
    let accessLevels = this.state.accessLevels;
    const {enqueueSnackbar} = this.props;

    const isBasicTouched = this.isBasicAccessLevelDataTouched(formData);
    const isAdvancedTouched = this.isAdvancedAccessLevelDataTouched(formData);

    for (let accessLevel of accessLevels) {
      if (accessLevel.accessLevel === 'compliance_dashboard_basic' && isBasicTouched) {
        this.dataProvider.update('compliance_dashboard_access_levels', {
          id: accessLevel.id,
          data: {
            powerBiGroupId: formData.basicPowerBiGroupId,
            powerBiReportId: formData.basicReportId,
            powerBiDatasetId: formData.basicDatasetId,
            powerBiGroupIdScope2: formData.basicPowerBiGroupIdScope2,
            powerBiReportIdScope2: formData.basicReportIdScope2,
            powerBiDatasetIdScope2: formData.basicDatasetIdScope2,
            powerBiGroupIdScope3: formData.basicPowerBiGroupIdScope3,
            powerBiReportIdScope3: formData.basicReportIdScope3,
            powerBiDatasetIdScope3: formData.basicDatasetIdScope3,
            powerBiGroupIdScope4: formData.basicPowerBiGroupIdScope4,
            powerBiReportIdScope4: formData.basicReportIdScope4,
            powerBiDatasetIdScope4: formData.basicDatasetIdScope4,
            powerBiGroupIdScope5: formData.basicPowerBiGroupIdScope5,
            powerBiReportIdScope5: formData.basicReportIdScope5,
            powerBiDatasetIdScope5: formData.basicDatasetIdScope5,
            powerBiGroupIdScope6: formData.basicPowerBiGroupIdScope6,
            powerBiReportIdScope6: formData.basicReportIdScope6,
            powerBiDatasetIdScope6: formData.basicDatasetIdScope6,
          },
        })
          .then(() => {
            enqueueSnackbar(`Ids for basic report updated successfully`, {
              variant: 'success',
            });
          })
          .catch((error) => {
            handleAPIErrors(error, this.props.history);
            enqueueSnackbar(`There was an error updating ids for basic report. Ids must not be null.`, {
              variant: 'error',
              autoHideDuration: 10000,
            });
            console.error(error);
          });
      } else if (accessLevel.accessLevel === 'compliance_dashboard_advanced' && isAdvancedTouched) {
        this.dataProvider.update('compliance_dashboard_access_levels', {
          id: accessLevel.id,
          data: {
            powerBiGroupId: formData.advancedPowerBiGroupId,
            powerBiReportId: formData.advancedReportId,
            powerBiDatasetId: formData.advancedDatasetId,
            powerBiGroupIdScope2: formData.advancedPowerBiGroupIdScope2,
            powerBiReportIdScope2: formData.advancedReportIdScope2,
            powerBiDatasetIdScope2: formData.advancedDatasetIdScope2,
            powerBiGroupIdScope3: formData.advancedPowerBiGroupIdScope3,
            powerBiReportIdScope3: formData.advancedReportIdScope3,
            powerBiDatasetIdScope3: formData.advancedDatasetIdScope3,
            powerBiGroupIdScope4: formData.advancedPowerBiGroupIdScope4,
            powerBiReportIdScope4: formData.advancedReportIdScope4,
            powerBiDatasetIdScope4: formData.advancedDatasetIdScope4,
            powerBiGroupIdScope5: formData.advancedPowerBiGroupIdScope5,
            powerBiReportIdScope5: formData.advancedReportIdScope5,
            powerBiDatasetIdScope5: formData.advancedDatasetIdScope5,
            powerBiGroupIdScope6: formData.advancedPowerBiGroupIdScope6,
            powerBiReportIdScope6: formData.advancedReportIdScope6,
            powerBiDatasetIdScope6: formData.advancedDatasetIdScope6,
          },
        })
          .then(() => {
            enqueueSnackbar(`Ids for advanced report updated successfully`, {
              variant: 'success',
            });
          })
          .catch((error) => {
            handleAPIErrors(error, this.props.history);
            enqueueSnackbar(`There was an error updating ids for advanced report. Ids must not be null.`, {
              variant: 'error',
              autoHideDuration: 10000,
            });
            console.error(error);
          });
      }
    }

  };

  render() {
    const {classes} = this.props;
    const { basicAccessLevel, advancedAccessLevel } = this.state;

    return (
      <div>
        <Paper elevation={2} className={classes.settingsContainer}>
          <SimpleForm save={this.submitForm} toolbar={<CustomToolbar/>}>
            <Grid container spacing={2} className={classes.form}>
              <Grid item xs={12}>
                {!this.state.accessLevels.length ? <CircularProgress className={classes.progressBar}
                                                                     variant="indeterminate"/> :
                    <div className={classes.complianceDashboardAccess}>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 1 to 3700</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupId}
                                       source="basicPowerBiGroupId" name="basicPowerBiGroupId" label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportId} source="basicReportId"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetId} source="basicDatasetId"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 3701 to 7400</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupIdScope2}
                                       source="basicPowerBiGroupIdScope2" name="basicPowerBiGroupIdScope2"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportIdScope2}
                                       source="basicReportIdScope2"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetIdScope2}
                                       source="basicDatasetIdScope2"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 7401 to 11100</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupIdScope3}
                                       source="basicPowerBiGroupIdScope3" name="basicPowerBiGroupIdScope3"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportIdScope3}
                                       source="basicReportIdScope3"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetIdScope3}
                                       source="basicDatasetIdScope3"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 11101 to 14800</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupIdScope4}
                                       source="basicPowerBiGroupIdScope4" name="basicPowerBiGroupIdScope4"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportIdScope4}
                                       source="basicReportIdScope4"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetIdScope4}
                                       source="basicDatasetIdScope4"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 14801 to 18500</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupIdScope5}
                                       source="basicPowerBiGroupIdScope5" name="basicPowerBiGroupIdScope5"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportIdScope5}
                                       source="basicReportIdScope5"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetIdScope5}
                                       source="basicDatasetIdScope5"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Free report - account/role ids from 18501 to 22200</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiGroupIdScope6}
                                       source="basicPowerBiGroupIdScope6" name="basicPowerBiGroupIdScope6"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiReportIdScope6}
                                       source="basicReportIdScope6"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={basicAccessLevel.powerBiDatasetIdScope6}
                                       source="basicDatasetIdScope6"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 1 to 3700</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupId}
                                       source="advancedPowerBiGroupId" name="advancedPowerBiGroupId" label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportId}
                                       source="advancedReportId"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetId}
                                       source="advancedDatasetId"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 3701 to 7400</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupIdScope2}
                                       source="advancedPowerBiGroupIdScope2" name="advancedPowerBiGroupIdScope2"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportIdScope2}
                                       source="advancedReportIdScope2"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetIdScope2}
                                       source="advancedDatasetIdScope2"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 7401 to 11100</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupIdScope3}
                                       source="advancedPowerBiGroupIdScope3" name="advancedPowerBiGroupIdScope3"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportIdScope3}
                                       source="advancedReportIdScope3"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetIdScope3}
                                       source="advancedDatasetIdScope3"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 11101 to 14800</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupIdScope4}
                                       source="advancedPowerBiGroupIdScope4" name="advancedPowerBiGroupIdScope4"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportIdScope4}
                                       source="advancedReportIdScope4"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetIdScope4}
                                       source="advancedDatasetIdScope4"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 14801 to 18500</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupIdScope5}
                                       source="advancedPowerBiGroupIdScope5" name="advancedPowerBiGroupIdScope5"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportIdScope5}
                                       source="advancedReportIdScope5"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetIdScope5}
                                       source="advancedDatasetIdScope5"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.singleAccessType}>
                        <Typography variant="subtitle2">Paid report - account/role ids from 18501 to 22200</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiGroupIdScope6}
                                       source="advancedPowerBiGroupIdScope6" name="advancedPowerBiGroupIdScope6"
                                       label="Group ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiReportIdScope6}
                                       source="advancedReportIdScope6"
                                       label="Report ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                          <Grid item xs>
                            <TextInput initialValue={advancedAccessLevel.powerBiDatasetIdScope6}
                                       source="advancedDatasetIdScope6"
                                       label="Dataset ID"
                                       className={classes.idInput}></TextInput>
                          </Grid>
                        </Grid>
                      </div>
                    </div>}
              </Grid>
            </Grid>
          </SimpleForm>
        </Paper>
      </div>
    );
  }
}

const CustomToolbar = props => (
    <Toolbar {...props} >
      <SaveButton className="save-compliance-dashboard-settings-button"/>
    </Toolbar>
);

const ComplianceDashboardSettings = withStyles(styles)(withDataProvider(styledComplianceDashboardSettings));

const ComplianceDashboardSettingsWithSnackbar = withSnackbar(ComplianceDashboardSettings);

function IntegrationNotistack() {
  return (
      <SnackbarProvider maxSnack={10}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}>
        <ComplianceDashboardSettingsWithSnackbar/>
      </SnackbarProvider>
  );
}

export default IntegrationNotistack;
